<template>
	<section>
		<fixed-header title="Receive Payments List" :records="pageInfo.totalItems">
			<template v-slot:center>
				<b-button v-if="checkClaim(CAN_POST_PAYMENT)" size="sm" to="/receivepayments/add" variant="primary"><i class="fa fa-plus" aria-hidden="true"></i> Receive Payment</b-button>
			</template>
		</fixed-header>
		<div class="animated fadeIn ReceivePayments--ReceivePayments-list">
			<div class="card margin-top-fixed-header h-50">
				<div class="card-body d-flex flex-column">
					<div class="d-flex justify-content-start align-items-end mb-2">
						<b-form-group label="Invoice Number" class="mr-2">
						<b-form-input v-model="filters.invoiceId" size="sm" type="text" @input="onSearch"></b-form-input>
						</b-form-group>
						<b-form-group label="Customer " class="mr-2">
						<b-form-input v-model="filters.companyName" size="sm" type="text" @input="onSearch"></b-form-input>
						</b-form-group>
            <date-range-picker :dateFrom="filters.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
						<div class="clear-filter-button-container">
						<b-button size="sm" @click="handleClearFilter">Clear filters</b-button>
						</div>
					</div>
					<grid-component
							isResizable
							isReorderable
							isSortable
              :canEdit="checkClaim(CAN_POST_PAYMENT)"
              :canDelete="checkClaim(CAN_POST_PAYMENT)"
							:gridId="gridId"
							:pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
							:itemData="itemData"
							:pageSizes="pageInfo.pageSize"
							:totalItems="pageInfo.totalItems"
							:fields="fields"
							:sortBy="pageInfo.sortBy"
							:sortOrder="pageInfo.sortOrder"
							:sortMethod="sortGrid"
							:handleRowClick="handleRowClick"
							:onDelete="onDelete"
              :styleCustom="'height: 335px'"
              @getData="onGetData"
              :isTblLoader="tblLoader"
						/>
				</div>
			</div>
		</div>
		<b-card>
			<b-tabs class="d-flex flex-column">
				<b-tab title="Payment details">
					<payment-details :receivePaymentId="selectedRowItemId" />
				</b-tab>
			</b-tabs>
		</b-card>
	</section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import  debounce from 'lodash/debounce';

import { dateTime, date } from '@/shared/filters';
import { SEARCH_DEBOUNCE_TIME, GRID_ID, GRID_PAGE_SIZES, PAGE_SIZE } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import DateFilters from '@/shared/components/DateFilters';
import FixedHeader from '@/shared/components/FixedHeader/index';
import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
import GridComponent from '@/shared/components/GridComponent';
import PaymentDetails from './components/PaymentDetails'

import gridFields from './fields';


export default {
	components: {
		DateFilters,
		GridSettings,
		FixedHeader,
		DateRangePicker,
		GridComponent,
		PaymentDetails
  },
  metaInfo: () => ({
    title: 'Receive Payments',
  }),
	data() {
		return {
			prepareColumnsData,
			fields: gridFields,
			date,
			gridId: GRID_ID.RECEIVE_PAYMENTS,
			pageable: {
				pageSizes: GRID_PAGE_SIZES,
			},
			selectedRowItemId: 0,
		};
	},
	computed: {
		...mapState('receivePayments', ['lastOpenedId']),
		...mapGetters('receivePayments', [
			'receivePaymentsList',
			'pageInfo',
			'selectedItemId' ,
			'tblLoader' ,
			'filters',
		]),
		...mapGetters('account', ['gridSettingsById']),
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
		itemData() {
			return this.receivePaymentsList.map((BillPayment) => ({ ...BillPayment, selected: BillPayment.id === this.selectedRowItemId }));
		},
	},
	filters: {
		dateTime,
	},
	methods: {
		...mapMutations('receivePayments', [
      'setItem'
		]),
		...mapActions('receivePayments', ['getAll',
		 'getById',
		 'deleteById',
		 'sortGrid',
		 'search',
		 ]),
		...mapActions('account', ['saveGridSettings']),
		onSearch: debounce(function (data) {
      if(typeof data === 'object') { Object.assign(this.filters,data) }
			this.search(this.filters);
		}, SEARCH_DEBOUNCE_TIME),
		async handleClearFilter() {
			/*this.clearFilters();
			Object.keys(this.filters).forEach(filterName => {
				this.filters[filterName] = null;
			});
			this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker*/

      this.clearObject(this.filters);

      console.log(this.filters);

			await this.search(this.filters);
		},
		handleRowClick(row) {
			/*this.setLastOpenedId(row.dataItem.id);*/
      this.setItem({ resource: 'lastOpenedId', payload: row.dataItem.id });
			this.selectedRowItemId = row.dataItem.id;
		},
    async onDelete({ id }) {
      const deleteConfirmed = await this.openConfirmBox({ message: 'Are you sure you want to delete payment?  This action cannot be undone.' });
      if (deleteConfirmed) {
        await this.deleteById(id);
        //Get the data
        await this.getAll({});
      }
    },
		async onGetData(params) {
			await this.getAll(params);
		},
	},
	watch: {
		async receivePaymentsList() {
      //This function sets the first row as the selected row
      this.selectedRowItemId = await this.setSelectedRowId(this.receivePaymentsList,this.selectedRowItemId,this.lastOpenedId);
		},
	},
	async mounted() {
		if(this.lastOpenedId) {
			this.selectedRowItemId = this.lastOpenedId;
		}

    this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
    await this.getAll({
			pageNumber: 0
		});
	},
	beforeDestroy() {
		//this.select({ id: null, isChecked: false });
	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#ReceivePayments-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#ReceivePayments-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}


.ReceivePayments {
  &--ReceivePayments-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}
</style>
